import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PreInitSettingsService } from './settings/pre-init-setting.service';
import { DatePipe } from '@angular/common';
import { ADPResourceService } from 'digital-core';
import { IRegisteredDevice } from 'src/app/model/claims/IRegisteredDevice';

@Injectable({
  providedIn: 'root'
})
export class DeviceRegistrationService {
  expApiUrl: string;
  clientName: string;

  constructor(
    private preInitSettingsService: PreInitSettingsService,
    private httpClient: HttpClient,
    private datePipe: DatePipe,
    private resourceService: ADPResourceService
  ) {
    this.expApiUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl + this.preInitSettingsService.getSettings().middleWare.accountPath + 'registerelitadevice';
    this.clientName = this.resourceService.getPortalSetting("Global_SourceClientName").Value;;
  }

  registerDevice(registeredDevice: IRegisteredDevice): Observable<any> {
    // Note: The CertificateNumber & ChildCertificateNumber is same intentionally, as the registeredDevice.certificateNumber is being sent as
    // child certificate so in future if we send the master certificate in registeredDevice.certificateNumber then we can update the ChildCertificateNumber
    // to it's corresponding value.  ChildCertificateNumber on the server side is being used to generate the GSSP token
    const body = {
        CertificateNumber: registeredDevice.certificateNumber,
        ChildCertificateNumber: registeredDevice.certificateNumber,
        DealerCode: registeredDevice.dealerCode,
        DeviceTypeCode: registeredDevice.deviceTypeCode,
        ItemDescription: registeredDevice.itemDescription,
        Manufacturer: registeredDevice.manufacturer,
        Model: registeredDevice.model,
        PurchasePrice: registeredDevice.purchasePrice,
        PurchasedDate: registeredDevice.purchasedDate,
        RegisteredItemName: registeredDevice.registeredItemName,
        RegistrationDate: this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
        SerialNumber: registeredDevice.serialNumber
    };
    return this.httpClient.post<IRegisteredDevice>(this.expApiUrl, body);
  }
}
